import styled from 'styled-components';
import { media } from '../../common/theme/media';

export const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${({ theme }) => theme.spaces.space4} 0 0;
  margin-bottom: -${({ theme }) => theme.spaces.space3};

  ${media.desktop`
    padding: ${({ theme }) => theme.spaces.space4} 0;
    margin-bottom: 0;
  `}
`;
